// components/PublicRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const PublicRoute = () => {
  const { authPayload } = useAuth();
  return authPayload?.id_token ? <Navigate to="/" replace /> : <Outlet />;
};

export default PublicRoute;
